__webpack_require__.p = "/kubekode.github.io/";